import React from "react";

const appContext = React.createContext({
    backendUri: '',
    userId: '',
    startFrom: ''
});

export default appContext;
